import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  HeaderContainer,
  Logo,
  Menu,
  MenuButton,
  MenuMobile,
  DrawerOverlay,
  DrawerContent,
  CloseButton,
  DivMenu,
} from "./styles";
import { logoSuprema, menu } from "../../assets/images";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const menuItems = [
    { label: "Home", path: "/" },
    { label: "Nossa história", path: "/history" },
    { label: "Produtos", path: "/products" },
    { label: "Receitas", path: "/revenues" },
    { label: "Fale Conosco", path: "/contact-us" },
  ];

  const handleNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
    setIsDrawerOpen(false); // fecha o drawer ao navegar
  };

  return (
    <HeaderContainer>
      <Logo
        src={logoSuprema}
        alt="Logo Suprema"
        onClick={() => navigate("/")}
      />
      <Menu>
        {menuItems.map((item) => (
          <MenuButton
            key={item.path}
            onClick={() => handleNavigate(item.path)}
            disabled={location.pathname === item.path}
            className={location.pathname === item.path ? "active" : ""}
          >
            {item.label}
          </MenuButton>
        ))}
      </Menu>

      {/* Ícone do menu mobile */}
      <MenuMobile onClick={() => setIsDrawerOpen(true)}>
        <img
          src={menu}
          alt="Abrir menu"
          style={{ width: "40px", height: "40px" }}
        />
      </MenuMobile>

      {/* Drawer lateral */}
      {isDrawerOpen && (
        <DrawerOverlay onClick={() => setIsDrawerOpen(false)}>
          <DrawerContent onClick={(e) => e.stopPropagation()}>
            <DivMenu>
              <h2
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#FFFFFF",
                  margin: "0px",
                }}
              >
                Menu
              </h2>
              <CloseButton onClick={() => setIsDrawerOpen(false)}>
                ×
              </CloseButton>
            </DivMenu>
            {menuItems.map((item) => (
              <MenuButton
                key={item.path}
                onClick={() => handleNavigate(item.path)}
                className={location.pathname === item.path ? "active" : ""}
              >
                {item.label}
              </MenuButton>
            ))}
          </DrawerContent>
        </DrawerOverlay>
      )}
    </HeaderContainer>
  );
};

export default Header;
